import React, { Component } from 'react';
import api from '../utils/api';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Form } from 'react-bootstrap';

class NewMember extends Component {
    constructor() {
        super();
        this.state = {
            first1: '',
            middle1: '',
            last1: '',
            first2: '',
            middle2: '',
            last2: '',
            address: '',
            address2: '',
            city: '',
            state: 'CA',
            zip: '',
            country: 'USA',
            phone1: '',
            phone2: '',
            email: '',
            passcode: '',
            memberType: '', // will default to DEVOTEE if not set
            referenceMemberTypes: [],
            isNameConfidential: false,
            error: '',
            success: ''
        };
    }

    componentDidMount() {
        this.fetchReferenceMemberTypes();
    }

    fetchReferenceMemberTypes = async () => {
        try {
            // Fetch reference type id for 'Member Type'
            const typesRes = await api.get('/api/reference_types');
            const memberTypeObj = typesRes.data.find(t => t.type_name === 'Member Type');
            if (!memberTypeObj) {
                this.setState({ referenceMemberTypes: [] });
                return;
            }
            // Fetch values for this type
            const valuesRes = await api.get('/api/reference_values', { params: { type_id: memberTypeObj.id } });
            this.setState({ referenceMemberTypes: valuesRes.data });
        } catch (err) {
            this.setState({ referenceMemberTypes: [] });
        }
    };

    validateForm = () => {
        const {
            first1, last1, /* memberType, */ email
        } = this.state;

        if (!first1 || !last1) return 'First name and Last name are required.';
        // Remove memberType required check

        // Improved email regex: no consecutive dots, basic structure
        if (
            email &&
            (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.includes('..'))
        ) {
            return 'Please enter a valid email address.';
        }

        return '';
    }

    addMember = (event) => {
        event.preventDefault();
        const error = this.validateForm();
        if (error) {
            this.setState({ error });
            return;
        }
        // Default memberType to DEVOTEE if not set
        const data = {
            ...this.state,
            memberType: this.state.memberType || 'DEVOTEE'
        };

        api.post("/api/members", data)
            .then((response) => {

                const memberId = response.data.memberId;
                console.log("New member created:", memberId);
                this.setState({ success: 'Member added successfully!' });
                this.props.history.replace(`/memberDetails/${memberId}`);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ error: 'Failed to add member. Please try again.' });
            });
    };

    onChangeInput = (event) => {
        const { name, value } = event.target;
        // Ensure no logic here is removing spaces
        this.setState({
            [name]: value
        });
    };

    onChangeCheckbox = (e) => {
        this.setState({ isNameConfidential: e.target.checked });
    };

    render() {
        const { error, success, referenceMemberTypes } = this.state;

        return (
            <div className="p-0">
                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}
                <div className="p-4 border border-secondary">
                    <div style={{ backgroundColor: "lightblue" }}>
                        <div className="text-center">Member</div>
                        <form onSubmit={this.addMember}>
                            <div className="form-row p-3">
                                <div className="col">
                                    <div className="md-form">
                                        <label htmlFor="firstName1">First name <span className="text-danger">*</span></label>
                                        <input
                                            onChange={this.onChangeInput}
                                            type="text"
                                            id="firstName1"
                                            placeholder="First Name"
                                            name="first1"
                                            className="form-control"
                                            value={this.state.first1}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="md-form">
                                        <label htmlFor="middleName1">Middle name</label>
                                        <input
                                            onChange={this.onChangeInput}
                                            type="text"
                                            id="middleName1"
                                            placeholder="Middle Name"
                                            name="middle1"
                                            className="form-control"
                                            value={this.state.middle1}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="md-form">
                                        <label htmlFor="lastName1">Last name <span className="text-danger">*</span></label>
                                        <input
                                            onChange={this.onChangeInput}
                                            type="text"
                                            id="lastName1"
                                            placeholder="Last Name"
                                            name="last1"
                                            className="form-control"
                                            value={this.state.last1}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ backgroundColor: "mistyrose" }}>
                                <div className="text-center">Spouse</div>
                                <div className="form-row p-3">
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="firstName2">First name</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="firstName2"
                                                placeholder="First Name"
                                                name="first2"
                                                className="form-control"
                                                value={this.state.first2}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="middleName2">Middle name</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="middleName2"
                                                placeholder="Middle Name"
                                                name="middle2"
                                                className="form-control"
                                                value={this.state.middle2}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="lastName2">Last name</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="lastName2"
                                                placeholder="Last Name"
                                                name="last2"
                                                className="form-control"
                                                value={this.state.last2}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ backgroundColor: "yellow" }}>
                                <div className="text-center bold-text">Address and other details</div>
                                <div className="form-row p-3">
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="address">Address Line 1</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="address"
                                                placeholder="Address"
                                                name="address"
                                                className="form-control"
                                                value={this.state.address}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="address2">Address Line 2</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="address2"
                                                placeholder="Address"
                                                name="address2"
                                                className="form-control"
                                                value={this.state.address2}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row p-3">
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="city">City</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="city"
                                                placeholder="City"
                                                name="city"
                                                className="form-control"
                                                value={this.state.city}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="state">State</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="state"
                                                placeholder="State"
                                                name="state"
                                                className="form-control"
                                                value={this.state.state}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="zip">ZipCode</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="zip"
                                                placeholder="Zip"
                                                name="zip"
                                                className="form-control"
                                                value={this.state.zip}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="country">Country</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="country"
                                                placeholder="Country"
                                                name="country"
                                                className="form-control"
                                                value={this.state.country}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row p-3">
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="email">E-Mail</label>
                                            <input
                                                onChange={this.onChangeInput}
                                                type="text"
                                                id="email"
                                                placeholder="Email Address"
                                                name="email"
                                                className="form-control"
                                                value={this.state.email}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="confidentialName" style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    id="confidentialName"
                                                    name="isNameConfidential"
                                                    checked={this.state.isNameConfidential}
                                                    onChange={this.onChangeCheckbox}
                                                    style={{ marginRight: '10px' }}
                                                />
                                                Keep name confidential
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="memberType">Member Type <span className="text-danger">*</span></label>
                                            <select
                                                onChange={this.onChangeInput}
                                                id="memberType"
                                                name="memberType"
                                                className="form-control"
                                                value={this.state.memberType || 'DEVOTEE'}
                                            >
                                                {referenceMemberTypes.length > 0 ? (
                                                    referenceMemberTypes.map(opt => (
                                                        <option key={opt.id} value={opt.value}>{opt.value}</option>
                                                    ))
                                                ) : (
                                                    <option value="DEVOTEE">DEVOTEE</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-row p-3">
                                    <div className="col">
                                        <div className="md-form">
                                            <Form.Group controlId="phone1" className="mb-3">
                                                <Form.Label>Primary Phone</Form.Label>
                                                <PhoneInput
                                                    country={'us'}
                                                    value={this.state.phone1}
                                                    onChange={(phone) => this.setState({ phone1: phone })}
                                                    inputProps={{
                                                        name: 'phone1',
                                                        required: false,
                                                        disabled: this.state.loading,
                                                    }}
                                                    enableSearch={true}
                                                    disableCountryCode={false}
                                                    placeholder="+1 (XXX) XXX-XXXX"
                                                    className="phone-input-custom"
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <Form.Group controlId="phone2" className="mb-3">
                                                <Form.Label>Secondary Phone</Form.Label>
                                                <PhoneInput
                                                    country={'us'}
                                                    value={this.state.phone2}
                                                    onChange={(phone) => this.setState({ phone2: phone })}
                                                    inputProps={{
                                                        name: 'phone2',
                                                        required: false,
                                                        disabled: this.state.loading,
                                                    }}
                                                    enableSearch={true}
                                                    disableCountryCode={false}
                                                    placeholder="+1 (XXX) XXX-XXXX"
                                                    className="phone-input-custom"
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <button type="submit" className="btn btn-primary m-1">Add Member</button>
                                <button type="button" className="btn btn-secondary m-1" onClick={() => { this.props.history.goBack() }}>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewMember;
